<!-- Install -->
<h2>Install</h2>
<p>run the following command in your favorite terminal to install the library</p>

<!-- Terminal -->
<div class="terminal" fxLayout="column" fxLayoutAlign="center center">
  <pre>ng add ngx-storage-firebaseui</pre>
</div>


<markdown src="assets/md/getting-started/e1.md"></markdown>


<h2 style="margin-top: 4rem">Next Steps</h2>
<a color="primary" mat-raised-button routerLink="" style="color:white;;">USAGE</a>
